import { Phone, Calendar } from "lucide-react";
import { BUSINESS } from "@/data/content";

// Mobile-only fixed bottom bar (Call Now + Book Now)
export default function MobileBottomBar() {
  return (
    <div
      data-testid="mobile-bottom-bar"
      className="fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 lg:hidden border-t border-black/10 bg-white/90 backdrop-blur-md"
    >
      <a
        href={BUSINESS.phoneHref}
        data-testid="bottom-call-now"
        className="flex items-center justify-center gap-2 py-4 text-[13px] uppercase tracking-[0.14em] text-[#050505] active:bg-black/5"
      >
        <Phone size={15} /> Call Now
      </a>
      <a
        href={BUSINESS.bookingUrl}
        target="_blank"
        rel="noreferrer"
        data-testid="bottom-book-now"
        className="flex items-center justify-center gap-2 bg-[#050505] py-4 text-[13px] uppercase tracking-[0.14em] text-white active:opacity-90"
      >
        <Calendar size={15} /> Book Now
      </a>
    </div>
  );
}
